import STQRYBunnyReadApi from 'stqry-bunny-read-api'

// Declared in views/layouts/mobile_web.html.erb
declare const projectId: number
// Declared in views/layouts/mobile_web.html.erb
declare const token: string

const stqryBunnyReadApi = new STQRYBunnyReadApi(ENV.PUBLISHED_CONTENT_HOST, projectId, 'mobile_web', token, import.meta.env.VITE_PUBLISHING_CRYPT_KEY)

export default stqryBunnyReadApi
